<template>
  <div class="feedback-box dark-mode">
    <div class="d-flex justify-content-between">
      <div class="font-weight-bold">{{ 'Rate your image' | trans }}</div>
      <div class="text-muted font-weight-bold"></div>
    </div>
    <div class="d-flex feedback-thumbs">
      <div class="w-100">
        <div class="feedback-btn w-100" v-bind:class="{'disabled': complete === false || this.isRatedUp() === true, 'active': this.isRatedUp() === true}" @click="thumbsUp">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="none" stroke="green" stroke-dasharray="80" stroke-dashoffset="80"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 11L12 3L15 4L14 10H21V13L18 20H7H3V11H7V20">
              <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.8s" values="80;0"/>
            </path>
          </svg>
          {{ 'Good result' | trans }}
        </div>
      </div>
      <div class="w-100">
        <div class="feedback-btn w-100" v-bind:class="{'disabled': complete === false || this.isRatedDown() === true, 'active': this.isRatedDown() === true}" @click="thumbsDown">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="none" stroke="red" stroke-dasharray="80" stroke-dashoffset="80"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 4H18L21 11V14H14L15 20L12 21L7 13H3V4H7V13">
              <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.8s" values="80;0"/>
            </path>
          </svg>
          {{ 'Not satisfied' | trans }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";
import FeedbackManager from "../../manager/FeedbackManager";

export default {
  name: "Rating",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
      ratedJobs: [],
      thumbsUpJobs: [],
      thumbsDownJobs: [],
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    thumbsUp() {
      if (this.isRated() === true || this.complete === false) {
        return;
      }
      this.ratedJobs.push(this.id);
      this.thumbsUpJobs.push(this.id);

      FeedbackManager.submitRating(this.currentJob, 1, 'aicreatorstudio', {style: this.currentJob.apiJob.conversion[0].options.style});
    },
    thumbsDown() {
      if (this.isRated() === true || this.complete === false) {
        return;
      }
      this.ratedJobs.push(this.id);
      this.thumbsDownJobs.push(this.id);

      FeedbackManager.submitRating(this.currentJob, -1, 'aicreatorstudio', {style: this.currentJob.apiJob.conversion[0].options.style});
    },
    isRatedUp() {
      if (this.thumbsUpJobs.includes(this.id)) {
        return true;
      }

      return false;
    },
    isRatedDown() {
      if (this.thumbsDownJobs.includes(this.id)) {
        return true;
      }

      return false;
    },
    isRated() {
        if (this.ratedJobs.includes(this.id)) {
          return true;
        }

        return false;
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>

.feedback-box {
  .feedback-thumbs {
    gap: 10px;
    justify-content: space-evenly;
  }

  .rating-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .feedback-text {
    gap: 10px;
    display: inline-flex;
    align-items: center;
  }

  gap: 20px;
  display: flex;
  flex-direction: column;

  .feedback-btn {
    display: inline-flex;
    background: #383838;
    border: 1px solid #595959;
    border-radius: 4px;
    gap: 10px;
    padding: 10px 20px;
    align-items: center;
    cursor: pointer;

    .dark-mode & {
      background: #383838;;
      border: 1px solid #595959;
      color: white;

      &:hover {
        background: #323232;
      }
    }

    &.active {
      color:black;
      background: #CCF4DC !important;
      &:hover {
        background: #CCF4DC !important;
      }
    }


    &:hover {
      background: #595959;
    }
  }

  .feedback-btn-star-1 {
    &.active {
      background: #fcc9c9 !important;
    }
    &:hover {
      background: #fcc9c9 !important;
    }
  }

  .feedback-btn-star-2 {
    &.active {
      background: #FFDADA !important;
    }
    &:hover {
      background: #FFDADA !important;
    }
  }

  .feedback-btn-star-3 {
    &.active {
      background: #FFF1D6 !important;
    }
    &:hover {
      background: #FFF1D6 !important;
    }
  }

  .feedback-btn-star-4 {
    &.active {
      background: #CCF4DC !important;
    }
    &:hover {
      background: #CCF4DC !important;
    }
  }

  .feedback-btn-star-5 {
    &.active {
      background: #b8f6d4 !important;
    }
    &:hover {
      background: #b8f6d4 !important;
    }
  }

  .feedback-btn-star {
    display: inline-flex;
    background: #F8F9FA;
    border: 1px solid #CBCBCB;
    border-radius: 4px;
    gap: 5px;
    padding: 10px 10px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &.disabled {
      cursor: not-allowed;
    }
    .dark-mode & {
      border: 1px solid #595959;
      color: white;

      &:hover {

      }
    }

    &:hover {
      background: #F2F2F2;
    }
  }
}
</style>
